<template>
    <a class="tower-link" :href="`/score.php?name=${ name }`" target="_blank">{{ title }}</a>
</template>

<script>
export default {
    props: {
        name: String,
        title: String,
    }
}
</script>

<style>

</style>